/** CellConnectZA homepage: verified high-resolution replacement photographs.
 * Theme-only: does not modify product media, inventory, prices or the live theme.
 * Replaces approved stock photos only; keeps all other photos and the hero intact.
 */
(() => {
  'use strict';
  const root = document.getElementById('MainContent');
  const catalogue = document.getElementById('cc-hq-iphone-catalogue');
  const originalData = document.getElementById('cc-home-image-originals');
  if (!root || !catalogue || root.dataset.ccImageQualityReady) return;
  const selector = 'img.im-img,img.sa-img,img.bb-img,img.td-img,img.m-pimg,.cch-tile img';
  const defaults = {
    '17-pro-max':'cosmic-orange','17-pro':'deep-blue','17':'black',
    '16-pro-max':'natural-titanium','16-pro':'desert-titanium','16-plus':'black','16':'black',
    '15-pro-max':'blue-titanium','15-pro':'natural-titanium','15-plus':'black','15':'black',
    '14-pro-max':'space-black','14-pro':'deep-purple','14-plus':'midnight','14':'midnight',
    '13-pro-max':'gold','13-pro':'sierra-blue','13-mini':'blue','13':'midnight',
    '12-pro-max':'pacific-blue','12-pro':'graphite','12-mini':'blue','12':'black',
    '11-pro-max':'midnight-green','11-pro':'space-gray','11':'black',
    'xs-max':'silver','xs':'silver','xr':'black','x':'silver','8-plus':'silver','8':'red'
  };
  const approved = new Set([
    'iPhone_17_Pro_Max.png','iPhone_17_Pro.png','iPhone_17.png','iPhone_16_Pro_Max.png',
    'iPhone_16_Pro.png','iPhone_16_Plus.png','iPhone_16.png','iPhone_15_Pro_Max.png',
    'iPhone_15_Pro.png','iPhone_15_Plus.png','iPhone_15.png','iPhone_14_Pro_Max.png',
    'iPhone_14_Pro.webp','iPhone_14_Plus.webp','iPhone_14.jpg','iPhone_13_Pro_Max.webp',
    'iPhone_13_Pro.webp','iPhone_13_Mini.webp','iPhone_13.jpg','iphone_12_Pro_Max.webp',
    'iPhone_12_Pro.jpg','iPhone_12_Mini.webp','iphone_12.webp','iPhone_11_Pro_Max.webp',
    'iPhone_11_Pro.png','iPhone_11.webp','iPhone_XS_Max.webp','iPhone_XS.webp',
    'iPhone_XR.webp','iPhone_X.webp','iPhone_8_Plus.jpg','iPhone_8.jpg',
    'tile-iphone-13.webp','tile-iphone-11.webp','tile2-iphone-11.webp','tile-iphone-8.webp',
    'tile-iphone-15.webp','tile-iphone-17-pro-max.webp',
    'iPhone-11_bc754801-e283-417b-a2fa-2315354ea4d1.webp','mwlv2plg-c_5_1.webp',
    'iphone_11_white_2_1_1_1_1_1_2_1_3.webp','iphone_11_white_2.webp',
    'silver_8c33b8dc-0b90-4a56-99fe-82ee4c123577_4_1_1_1_1_1_1_1_1_1.webp',
    'iPhone12ProGraphite.webp',
    'iphone_13_starlight_pure_back_iphone_13_starlight_front_2-up_screen__usen_1_6_1_1_1_1_1_1_1.webp',
    'iphone_13_green_pure_back_iphone_13_green_pure_front_2-up_screen__usen_2_1_1_1_1_1.webp',
    'iphone_13_mini_midnight_pure_back_iphone_13_midnight_pure_front_2-up_screen__usen_2_1_1_1_1_1_1.webp',
    'iphone_13_pro_max_graphite_pdp_image_position-1a__wwen_3.webp',
    'iphone_14_midnight-5_3_1_2_1_1_1_1_1_1.webp',
    'iphone_14_pro_max_space_black_pdp_image_position-1a__eaen_1_1_5.webp',
    'iphone_15_plus_black_pdp_image_position-1__wwen_4_1.webp',
    'iphone_15_pro_blue_titanium_pure_back_iphone_15_pro_blue_titanium_pure_front_2up_screen__usen.png',
    'iphone_15_pro_natural_titanium_pdp_image_position_6_2_1_1.webp',
    'iPhone-16_706745ce-6c7e-406f-bdc7-f77c02594fe0_1.webp',
    'iphone_16_plus_teal_pdp_image_position_1__wwen_1_1_1.webp',
    'iphone_16_pro_black_titanium_pdp_image_position_1__gben_1.webp',
    'iphone_17_lavender_pdp_image_position_1__wwen_2.webp',
    'iPhone_17_Pro_-_Cosmic_Orange.webp','iPhone_17_Pro_Max_-Cosmic_Orange.webp',
    'Silver_fb6faaa1-2722-4d3a-a228-83678f8ef87e.webp',
    'Silver_78c666d4-8154-4e09-aee7-1991e0f42a3f.webp'
  ].map(s => s.toLowerCase()));
  const replacementMap = new Map(), originals = new Map(), states = new WeakMap();
  const tracked = new WeakSet(), pending = new Set();
  const steps = [240,480,720,960,1440,1920,2400];
  let frame = 0;
  const api = {version:'3.0.2', replacementPhotos:0, models:0, replaced:0, failed:0};
  window.cczaHomepageImageQuality = api;
  function urlOf(raw) {
    try {
      const u = new URL(raw, document.baseURI);
      if ((u.hostname === location.hostname && /^\/cdn\/shop\/(files|products)\//.test(u.pathname)) ||
          (u.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(u.pathname))) return u;
    } catch (_) { /* Keep the existing image for invalid or external URLs. */ }
    return null;
  }
  function keyOf(u) {return decodeURIComponent(u.pathname.split('/').pop()).toLowerCase();}
  try {
    JSON.parse(catalogue.textContent).forEach(item => {
      if (item && item.width >= 1000 && item.height >= 1000 && urlOf(item.src)) {
        replacementMap.set(item.model + '|' + item.colour, item);
      }
    });
    if (originalData) JSON.parse(originalData.textContent).forEach(item => {
      if (item && item.width > 0 && item.height > 0) {
        const u = urlOf(item.src); if (u) originals.set(keyOf(u), item);
      }
    });
  } catch (_) {return;}
  if (!replacementMap.size) return;
  api.replacementPhotos = replacementMap.size;
  api.models = new Set(Array.from(replacementMap.values(), item => item.model)).size;
  root.dataset.ccImageQualityReady = '3';
  function normalise(text) {return String(text || '').toLowerCase().replace(/[_-]+/g,' ').replace(/\s+/g,' ').trim();}
  function modelOf(text) {
    const m = normalise(text).match(/\biphone\s*(xs(?:\s*max)?|xr|x|(?:17|16|15|14|13|12|11|8)(?:\s*(?:pro\s*max|pro|plus|mini))?)\b/);
    return m ? m[1].replace(/\s+/g,'-') : null;
  }
  function colourOf(text) {
    const m = normalise(text).match(/\b(cosmic orange|deep blue|desert titanium|natural titanium|blue titanium|black titanium|white titanium|midnight green|sierra blue|pacific blue|space black|deep purple|space gr[ae]y|starlight|midnight|graphite|lavender|silver|gold|teal|red|white|black|green|blue|pink|yellow|purple)\b/);
    return m ? m[1].replace('grey','gray').replace(/\s+/g,'-') : null;
  }
  function canonicalColour(model, colour) {
    if (['x','xs','xs-max'].includes(model) && colour === 'white') return 'silver';
    if (['x','xs','xs-max','8','8-plus'].includes(model) && colour === 'black') return 'space-gray';
    if (model.includes('pro') && colour === 'blue') {
      if (model.startsWith('12')) return 'pacific-blue';
      if (model.startsWith('13')) return 'sierra-blue';
      if (model.startsWith('15')) return 'blue-titanium';
      if (model.startsWith('17')) return 'deep-blue';
    }
    return colour;
  }
  function choose(img, key) {
    if (!approved.has(key) && !img.closest('.cch-tile')) return null;
    const card = img.closest('.bb-card,.td-card,.sa-card,.m-pcard');
    const title = card && card.querySelector('.bb-name,.td-name,.sa-name,.m-pname');
    const label = title ? title.textContent : img.alt;
    const model = modelOf(label) || modelOf(key);
    if (!model || !defaults[model]) return null;
    const variant = card && card.querySelector('.m-pvariant');
    const colour = colourOf(label + ' ' + (variant ? variant.textContent : '')) ||
      (img.closest('.cch-tile') ? defaults[model] : (colourOf(key) || colourOf((originals.get(key) || {}).alt) || defaults[model]));
    // Explicit colour mismatches are not silently changed to another colour.
    return replacementMap.get(model + '|' + canonicalColour(model, colour)) || null;
  }
  function set(img,name,value) {if (img.getAttribute(name) !== value) img.setAttribute(name,value);}
  function displayWidth(img, info) {
    const r = img.getBoundingClientRect(), css = getComputedStyle(img);
    let w = Math.max(r.width,img.clientWidth) - (parseFloat(css.paddingLeft)||0) - (parseFloat(css.paddingRight)||0);
    const h = Math.max(r.height,img.clientHeight) - (parseFloat(css.paddingTop)||0) - (parseFloat(css.paddingBottom)||0);
    if (w < 1 || h < 1) return 320; // Hidden Load More cards retain native lazy loading.
    const fitted = h * info.width / info.height;
    if (css.objectFit === 'contain') w = Math.min(w,fitted);
    else if (css.objectFit === 'cover') w = Math.max(w,fitted);
    return Math.max(1,Math.ceil(w*1.08));
  }
  function restore(img,state) {
    state.failed = true; api.failed++;
    for (const name of ['sizes','srcset','width','height','src']) {
      const value = state.original[name];
      if (value === null) img.removeAttribute(name); else img.setAttribute(name,value);
    }
    for (const source of state.sources || []) for (const name of ['srcset','sizes','type']) {if(source[name]===null)source.element.removeAttribute(name);else source.element.setAttribute(name,source[name]);}
    img.removeAttribute('data-cc-hq-replacement');
    img.removeAttribute('data-cc-image-quality');
    report();
  }
  function improve(img) {
    if (!img.isConnected || !root.contains(img)) return;
    const tile = img.closest('.cch-tile'), picture = img.closest('picture');
    if (picture && !tile) return;
    let u = urlOf(img.getAttribute('src') || '');
    if (!u && tile) {try {u = new URL(img.getAttribute('src') || '', document.baseURI);} catch (_) {return;}}
    if (!u) return;
    const key = keyOf(u);
    let state = states.get(img);
    if (state && key !== state.oldKey && key !== state.newKey) {states.delete(img);state=null;}
    if (!state) {
      const target = choose(img,key);
      if (!target) return;
      state = {oldKey:key,newKey:keyOf(urlOf(target.src)),target,failed:false,original:{}};
      for (const name of ['src','srcset','sizes','width','height']) state.original[name] = img.getAttribute(name);
      state.sources = picture ? Array.from(picture.querySelectorAll('source'), element => ({element, srcset:element.getAttribute('srcset'), sizes:element.getAttribute('sizes'), type:element.getAttribute('type')})) : [];
      states.set(img,state);
    }
    if (state.failed) return;
    const info = state.target, maximum = Math.min(2400,info.width);
    const widths = steps.filter(v => v < maximum); widths.push(maximum);
    const at = width => {const url=urlOf(info.src);url.searchParams.set('width',String(width));return url.href;};
    const slot = displayWidth(img,info);
    set(img,'sizes',slot+'px');
    const candidates = widths.map(w=>at(w)+' '+w+'w').join(', ');
    for (const source of state.sources) {set(source.element,'srcset',candidates);set(source.element,'sizes',slot+'px');source.element.removeAttribute('type');}
    set(img,'srcset',candidates);
    set(img,'src',at(Math.min(960,maximum)));
    // Square stock photography retains the existing card bounds; the portrait
    // image keeps its real aspect ratio rather than stretching the phone.
    const attrWidth = Number(state.original.width) || Math.min(600,info.width);
    set(img,'width',String(attrWidth));
    set(img,'height',String(Math.round(attrWidth*info.height/info.width)));
    if (!img.hasAttribute('data-cc-hq-replacement')) api.replaced++;
    set(img,'data-cc-hq-replacement',info.model+'|'+info.colour);
    set(img,'data-cc-image-quality','replacement-v3');
  }
  function report() {
    if (!new URL(location.href).searchParams.has('cc_image_check')) return;
    let panel=document.getElementById('cc-image-quality-check');
    if (!panel) {
      panel=document.createElement('output');panel.id='cc-image-quality-check';
      panel.style.cssText='position:fixed;bottom:50px;left:10px;right:10px;z-index:2147483647;padding:10px;background:#fff;color:#111;border:2px solid #111;font:12px/1.4 monospace;max-height:34vh;overflow:auto;white-space:pre-wrap;';
      document.body.appendChild(panel);
    }
    const rows=['CC REAL PHOTO REPLACEMENTS '+api.version+'; catalogue='+api.replacementPhotos+' photos; models='+api.models+'; failures='+api.failed];
    [['Models','img.im-img'],['Bargain Bin','img.bb-img'],['Top Deals','img.td-img'],['Latest Arrivals','img.sa-img'],['Top Sellers','.cch-tile img']].forEach(([name,sel])=>{
      const all=Array.from(root.querySelectorAll(sel)).filter(i=>modelOf(i.alt));
      const replaced=all.filter(i=>i.hasAttribute('data-cc-hq-replacement'));
      const loaded=replaced.filter(i=>{const u=urlOf(i.currentSrc||i.src);return i.complete&&i.naturalWidth>0&&u&&keyOf(u).startsWith('ccza-hq-');});
      const sample=replaced[0], info=sample&&states.get(sample).target;
      rows.push(name+': '+replaced.length+'/'+all.length+' replaced; '+loaded.length+' loaded'+(info?' | '+info.model+' '+info.colour+' | original '+info.width+'x'+info.height:''));
    });
    panel.textContent=rows.join('\n');
  }
  function enqueue(img) {
    pending.add(img);
    if (!frame) frame=requestAnimationFrame(()=>{frame=0;const batch=Array.from(pending);pending.clear();batch.forEach(improve);report();});
  }
  const resize=typeof ResizeObserver==='function'?new ResizeObserver(entries=>entries.forEach(e=>enqueue(e.target))):null;
  function track(img) {
    if (!tracked.has(img)) {
      tracked.add(img);if(resize)resize.observe(img);
      img.addEventListener('load',()=>{enqueue(img);});
      img.addEventListener('error',()=>{const s=states.get(img);if(s&&!s.failed)restore(img,s);});
    }
    enqueue(img);
  }
  function scan(node) {if(!(node instanceof Element))return;if(node.matches(selector))track(node);node.querySelectorAll(selector).forEach(track);}
  new MutationObserver(records=>records.forEach(record=>{
    if(record.type==='attributes'){if(record.target.matches(selector))track(record.target);}
    else {record.addedNodes.forEach(scan);record.removedNodes.forEach(node=>{
      if(!(node instanceof Element))return;
      const gone=node.matches(selector)?[node]:[];gone.push(...node.querySelectorAll(selector));
      gone.forEach(img=>{if(!root.contains(img)){if(resize)resize.unobserve(img);tracked.delete(img);pending.delete(img);}});
    });}
  })).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
  scan(root);
  window.addEventListener('load',report,{once:true});
  window.addEventListener('resize',()=>root.querySelectorAll(selector).forEach(enqueue),{passive:true});
  document.addEventListener('shopify:section:load',e=>scan(e.target));
})();
